export const resetTurnstileToken = () => {
  window?.turnstile?.reset();
};
